/**
 * Ein Verlaufseintrag der Antwort ohne Text, aber mit Karten. (01.10.2026, Ticket 2893)
 *
 * Die Dateien eines Telegram-Zuges (Bild, PDF, Audio) kommen NACH der Antwort in denselben Verlauf — als Eintrag
 * ohne Text, nur mit `toolCards`. Dieselben Karten zeichnen sie wie bei einem Chat-Zug; eine leere Blase davor
 * wäre Rauschen. Der Abruf des Verlaufs (hydrateFromServer) und der Live-Strom (onMessage) fragen hier.
 */
export function istNurKarten(rolle: string, text: unknown, karten: unknown): boolean {
  return rolle === "bot" && typeof text === "string" && text.trim() === "" && Array.isArray(karten) && karten.length > 0;
}
